import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=27e9d8ee&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=ts"
export * from "./CustomerList.vue?vue&type=script&lang=ts"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=27e9d8ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e9d8ee",
  null
  
)

export default component.exports